<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export PO</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/po">
					Back to Purchase Order List
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>
			<div>
				<b-datepicker :date-formatter="dateFormatter" placeholder="Starting Date" v-model="startingDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</div>

			<div>
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Ending Date"
					v-model="endingDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-button type="is-info" @click="exportPO()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			po: [],
			exportPo: [],
			totalLoop: 0,
			progress: 0,
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null
		}
	},

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		exportPO: async function() {
			// Set default data
			this.po = []
			this.exportPo = []

			this.totalLoop = 0
			this.progress = 0

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			// To filter with start and end date
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: 1,
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getPO({ data })

			// Loop to get all data
			if (apiGetPO) {
				const total = apiGetPO.data.total
				const totalLoop = Math.ceil(apiGetPO.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					const result = await this.getPO(skip)

					result.map(item => {
						this.po.push(item)
					})
				}

				this.progress = 100
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false

				return
			}

			// Get po details with products
			if (this.po.length > 0) {
				let count = 0
				// this.po.map(async po => {
				for (const po of this.po) {
					count++
					const brand = po.brand
					const shop = po.shop

					this.progress = (count / this.po.length) * 100

					var data = {
						id: po._id,
						populate_purchase_order: ['author', 'supplier', 'shop', 'brand'],
						populate_purchase_order_item: ['product']
					}

					const apiGetPO = await this.$api.getPODetail({ data })

					this.exportPo[po._id] = apiGetPO.data
				}
			}

			let finalData = ''

			// Header
			finalData += 'PO CODE,DATE,TIME,USER,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,QUANTITY,PRICE,NET AMOUNT\r\n'

			for (let po in this.exportPo) {
				const purchase_order = this.exportPo[po].purchase_order
				const purchase_order_items = this.exportPo[po].purchase_order_items

				let total_request = 0
				let total_amount = 0

				purchase_order_items.map(po_items => {
					const product = po_items.product

					const product_price = product.commission > 0 || product.original_price < 2 ? product.price : product.original_price

					const toAdd = [
						purchase_order.code,
						this.$moment(purchase_order.createdAt).format('DD/MM/YY'),
						this.$moment(purchase_order.createdAt).format('hh:mm a'),
						purchase_order.author.name,
						product.bd_code,
						product.barcode,
						'"' + product.name + '"',
						purchase_order.brand.name,
						purchase_order.brand.code,
						po_items.qty,
						product_price,
						product_price * po_items.qty
					]

					total_request += po_items.qty
					total_amount += product_price * po_items.qty

					let row = toAdd.join(',')

					finalData += row + '\r\n'
				})

				finalData += ',,,,,,,,Total,' + total_request + ',,' + total_amount + '\r\n\r\n'
			}

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Warehouse_PO_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false

			this.isLoading = false
		},

		getPO: async function(skip = 0) {
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: this.limit,
				populate: ['author', 'supplier', 'shop', 'brand'],
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getPO({ data })

			return apiGetPO.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
